import React, { useEffect, useState } from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import { advisoryBoardService } from '../services';
import { resolveMediaUrl } from '../services/api';
import PageBreadcrumb from '../components/PageBreadcrumb';

const AdvisoryBoard = () => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMembers = async () => {
            try {
                const response = await advisoryBoardService.getAll();
                setMembers(response.data.data || []);
            } catch (error) {
                console.error('Error fetching advisory board members:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchMembers();
    }, []);

    const socialIcons = {
        facebook: FaFacebook,
        instagram: FaInstagram,
        twitter: FaTwitter,
        linkedin: FaLinkedin,
        youtube: FaYoutube,
    };

    return (
        <div className="bg-gray-50">
            <PageBreadcrumb
                title="Advisory Board"
                description="Meet the people guiding our mission and growth."
                items={[{ label: 'Advisory Board' }]}
            />

            <section className="py-16">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    {loading ? (
                        <div className="py-12 text-center">
                            <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-emerald-600"></div>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                            {members.map((member) => (
                                <div key={member.id} className="overflow-hidden rounded-xl bg-white shadow-lg transition hover:-translate-y-1 hover:shadow-xl">
                                    <div className="h-64 w-full bg-gray-100">
                                        {member.photo ? (
                                            <img src={resolveMediaUrl(member.photo)} alt={member.name} className="h-full w-full object-cover" />
                                        ) : (
                                            <div className="flex h-full items-center justify-center text-gray-400">No Photo</div>
                                        )}
                                    </div>
                                    <div className="p-6">
                                        <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
                                        <p className="mt-1 text-sm font-semibold text-emerald-600">{member.position}</p>
                                        <div className="mt-4 flex gap-3">
                                            {Object.entries(member.social_links || {}).map(([key, url]) => {
                                                if (!url || !socialIcons[key]) return null;
                                                const Icon = socialIcons[key];
                                                return (
                                                    <a key={key} href={url} target="_blank" rel="noreferrer" className="text-gray-500 transition hover:text-emerald-600">
                                                        <Icon />
                                                    </a>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default AdvisoryBoard;
